import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MatchesService {

  constructor(private http: HttpClient) { }

  dryRun(accountId: string, emailDetailId: string): Observable<any> {
    let params = {
      accountId: accountId,
      emailDetailId: emailDetailId
    };

    return this.http
      .post(
        `/api/v1/admin/matches/dryrun`, params
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/matches.service.ts